module.exports = __webpack_public_path__ + "media/damages/car-rl-b894fe9f.png";